import { c as _c } from "react/compiler-runtime";
import Script from "next/script";
export const GoogleAnalytics: React.FC<{
  gaMeasurementId: string;
}> = t0 => {
  const $ = _c(7);
  const {
    gaMeasurementId
  } = t0;
  const t1 = `https://www.googletagmanager.com/gtag/js?id=${gaMeasurementId}`;
  let t2;
  if ($[0] !== t1) {
    t2 = <Script strategy="afterInteractive" async={true} src={t1} />;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const t3 = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){window.dataLayer.push(arguments);}
      gtag('js', new Date());

      gtag('config', '${gaMeasurementId}');
`;
  let t4;
  if ($[2] !== t3) {
    t4 = <Script id="google-analytics" strategy="afterInteractive">{t3}</Script>;
    $[2] = t3;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== t2 || $[5] !== t4) {
    t5 = <>{t2}{t4}</>;
    $[4] = t2;
    $[5] = t4;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  return t5;
};